import React, {Component} from "react";
import { Menu} from 'antd';
import { withRouter } from 'react-router';

import '../../assets/css/admin.less'
import './index.less'
import memoryUtils from "../../utils/memoryUtils";

/**
 * 左侧路由组件
 */

class LeftAd extends Component{

    state = {
        role:'none',
        another:'block'
    };

    handleClick= (e)=> {
        switch (e.key) {
            case '1':
                this.props.history.push("/student");
                break;
            case '2':
                this.props.history.push("/grade");
                break;
            case '3':
                this.props.history.push("/score");
                break;
            case '4':
                /*let director = sessionStorage.getItem("caseTo");
                this.props.history.push(director?director:"/check");*/
                document.getElementsByClassName("ant-menu-item")[4].style.setProperty("display","block");
                document.getElementsByClassName("ant-menu-item")[5].style.setProperty("display","block");
                break;
            /*case '5':
                sessionStorage.setItem("caseTo","/check");
                this.props.history.push("/check");
                break;
            case '6':
                sessionStorage.setItem("caseTo","/illCase");
                this.props.history.push("/illCase");
                break;*/
            case '7':
                this.props.history.push("/paper");
                break;
            case '8':
                this.props.history.push("/analysis");
                break;
            case '9':
                this.props.history.push("/teacher");
                break;
            case '10':
                this.props.history.push("/skillAd");
                break;
            case '11':
                this.props.history.push("/caseAd");
                break;
            case '12':
                this.props.history.push("/manage");
                break;
        }
    };

    questionClick=(url)=> {
        this.props.history.push(url)
    };

    componentDidMount() {
        if(memoryUtils.user.authority==="ADMIN"){
            this.setState({
                role:'block',
                another:'none'
            })
        }
    }

    render (){
        return (
            <div className="left">
                <Menu style={{ width: 210 }} defaultSelectedKeys={['1']} defaultOpenKeys={['sub1']}>
                    <Menu.Item key="1" onClick={this.handleClick.bind(this)}>
                        学生管理
                    </Menu.Item>
                    <Menu.Item key="2" onClick={this.handleClick.bind(this)}>
                        班级管理
                    </Menu.Item>
                    <Menu.Item key="3" onClick={this.handleClick.bind(this)} style={{display:this.state.another}}>
                        学生成绩
                    </Menu.Item>
                    <Menu.Item key="4" onClick={this.handleClick.bind(this)}>
                        试题管理
                    </Menu.Item>
                    <Menu.Item key="5" onClick={this.questionClick.bind(this,"/check")} style={{display:'none'}}>
                        综合考核
                    </Menu.Item>
                    <Menu.Item key="6" onClick={this.questionClick.bind(this,"/illCase")} style={{display:'none'}}>
                        病例考核
                    </Menu.Item>
                    <Menu.Item key="7" onClick={this.handleClick.bind(this)}>
                        试卷管理
                    </Menu.Item>
                    <Menu.Item key="8" onClick={this.handleClick.bind(this)} style={{display:this.state.another}}>
                        数据分析
                    </Menu.Item>
                    <Menu.Item key="9" onClick={this.handleClick.bind(this)} style={{display:this.state.role}}>
                        教师管理
                    </Menu.Item>
                    <Menu.Item key="10" onClick={this.handleClick.bind(this)} style={{display:this.state.role}}>
                        技能训练
                    </Menu.Item>
                    <Menu.Item key="11" onClick={this.handleClick.bind(this)} style={{display:this.state.role}}>
                        案例学习
                    </Menu.Item>
                    <Menu.Item key="12" onClick={this.handleClick.bind(this)} style={{display:this.state.role}}>
                        配置管理
                    </Menu.Item>
                </Menu>
            </div>
        )
    }
}
export default withRouter(LeftAd);